<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="purchase-order-details" [ngClass]="{ 'full-width-container1': !showDetailSection, 'half-width-container1': showDetailSection }" style="display: flex; flex-direction: column;overflow-x: hidden;">
     
      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">

          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content #pdfContent class="ship-fscoll hgt ship-pr-sec">
                  <div class="purchase-order-details-title">

                            <!-- <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
                                <div id="purchaseOrderDetails">
                                    Create Purchase Order
                                </div>
                                <button mat-button color="primary"
                                        style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                                        (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
                            </div> -->
                            <div style="display: flex; justify-content: space-between; align-items: center; margin: 10px 0;">
                                <!-- Purchase Order Info -->
                                <div id="purchaseOrderDetails" style="font-size: 22px; font-weight: 800;">
                                    Purchase Order: {{this.firstFormGroup.get('purchaseOrderRefNumber')?.value}}
                                </div>

                                <!-- Action Buttons -->
                                <div style="display: flex; gap: 10px;">
                                    <button mat-stroked-button color="primary" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;color:#42A190;background-color: #D9E0E4;" (click)="downloadPO()">
                                    Download PO <mat-icon style="color:#42A190;">download</mat-icon>
                                    </button>

                                    <button mat-raised-button color="warn" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px; background-color: #FF8900;" (click)="rejectPO()">
                                    <!-- {{ status === 'Rejected' ? 'Rejected' : 'Reject' }} -->
                                      Reject
                                    </button>

                                    <button mat-raised-button color="primary" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #1F7E3F;" (click)="acceptPO()">
                                    <!-- {{ status === 'Approved' ? 'Accepted' : 'Accept' }} -->
                                      Accept
                                    </button>

                                    <button mat-button color="primary" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #E6E6E6;" (click)="close(true)">
                                    Close <mat-icon>navigate_next</mat-icon>
                                    </button>
                                </div>
                            </div>

                    </div>
                  <div style="width:100%;">
                      
                      <div>
                          <div style="display: flex;justify-content: space-between;align-items: center;margin-top:30px">
                            <div>
                              <form [formGroup]="secondFormGroup">
                                <div class="form-item-row" style="flex-direction: column-reverse;">
                                    <div style="display: flex; flex-direction: column; width: 100%; height:  100%;">
                                        <label>Preferred Currency<span class="required-star" style="color: red;margin-left: 2px;">*</span></label>
                                        <app-paginated-autocomplete-manual style="background-color: white!important; margin-bottom: 10px; color: white!important;" [displayWithFunc]="filterFieldCurrencyNameDisplayFn"
                                        [dataSrc]="boundGetCurrencyAutoComplete" [controlName]="'supplierCurrency'" [control]="getCurrencyControl()"
                                        [readonly]="true" >
                                    </app-paginated-autocomplete-manual>
                                    </div> 
                                    <small *ngIf="secondFormGroup || secondFormGroup['controls']['supplierCurrency']['dirty'] || secondFormGroup['controls']['supplierCurrency']['touched']" class="form-error-msg">
                                        <div style="padding:2px;" *ngIf="secondFormGroup.controls['supplierCurrency'].hasError('required')">
                                            *Currency should not be empty.
                                        </div>
                                    </small>
                                    <small class="form-error-msg" style="color: blue;">
                                      <div style="padding:2px;" >
                                        1 {{ secondFormGroup.get('supplierCurrency')?.value?.currencyCode || 'No Currency' }} = 1 {{headerData?.currencyId?.currencyCode}} 
                                       ( as of {{currentdate }})
                                      </div>
                                  </small>
                                </div> 
                                
                              </form>
                            </div>
                            
                          </div>
                          <div style="display: flex; flex-direction: column; overflow-x: auto; width: 100%;margin-top:70px">
                              
                              <form [formGroup]="lineItemtableForm">

                                <ngx-datatable
                                  #table
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'force'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  >
                                
                                  <ngx-datatable-column name="S.No." [width]="100">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('position')" readonly style="width: 40px;" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      
                                      <ng-container *ngIf="isNew(rowIndex)" >
                                          <app-paginated-autocomplete-manual
                                          [displayWithFunc]="filterFieldSupplierProductNameDisplayFn"
                                          [dataSrc]="boundGetSupplierProductAutoComplete"
                                          [controlName]="'addedLineItempartNumber'"
                                          [control]="getPartNumberControl(rowIndex)"
                                          [placeholder]="'Select Part NUmber'"
                                          [label]="'Part Number'"
                                          (autoCompleteOptionSelected)="onPartNumberSelected($event,rowIndex)"
                                        >
                                        </app-paginated-autocomplete-manual>

                                      
                                        
                                      </ng-container>

                                      <ng-container *ngIf="!isNew(rowIndex)">
                                        <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('partNumber')" readonly 
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                      </ng-container>
                                      
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierPartNumber')" readonly 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                     
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Item Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('itemDescription')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        matTooltipClass="mat-tooltip-custom"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Buyer Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('buyerComment')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierComment')"
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"
                                        ></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>
                                  
                                  <ngx-datatable-column name="Customs Code">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('customsCode')" readonly
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('quantity')"
                                        [disabled]="true" readonly onkeypress="return event.charCode >= 48 && event.charCode <= 57" 
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column  name="Quoted Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierQuantity')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('uom')" readonly style="width: 100px;" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput pattern="[A-Za-z\\s]*" style="width: 100px;" [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierUom')" readonly (keypress)="allowOnlyLetters($event)" 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Unit Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">
                                          Quoted Unit Cost <span class="required-star">*</span>
                                        </span>
                                  
                                        <mat-slide-toggle
                                          (change)="getColumn('requestedUnitCost') ? showToggleColumns(getColumn('requestedUnitCost')) : null" 
                                          [checked]="getColumn('requestedUnitCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <!-- This renders the built-in sort icon -->
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)" 
                                        [disabled]="true" step="any" 
                                        readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                            

                                  <ngx-datatable-column type='button' name="Requested Unit Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('discount').value | number: '1.3-3' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Total Cost" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">Quoted Total Cost</span>
                                  
                                        <mat-slide-toggle
                                          (change)="getColumn('requestedTotalCost') ? showToggleColumns(getColumn('requestedTotalCost')) : null" 
                                          [checked]="getColumn('requestedTotalCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost')"
                                        [disabled]="true" step="any" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                                  

                                  <ngx-datatable-column type='button' name="Requested Total Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost').value | number: '1.3-3' }}
                                    
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      Lead Time <span class="required-star">*</span>
                                    </ng-template>
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('leadTime')" style="width: 100px;" readonly 
                                      [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column>


                                  <!-- <ngx-datatable-column type='button' *ngIf="getColumn('attachments')?.visible" name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                                  <!-- <ngx-datatable-column name="" [width]="80">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                  
                                      <button type='button' *ngIf="!isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>close</mat-icon>
                                      </button>

                                      <button type='button' *ngIf="isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="restoreLineitem(rowIndex)">
                                        <mat-icon>restore</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->
                                </ngx-datatable>
                              </form>

                          </div>
                          <div style="margin: 30px 0px; float: none">
                            <form [formGroup]="secondFormGroup">
                              <div class="cost-summary-container">
                                <!-- First Table -->
                                <table class="summary-table">
                                  <tbody>
                                    <tr>
                                      <td><b>Total <span *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode!== null">
                                        ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode}})
                                        </span></b></td>
                                      <td>
                                        {{ (secondFormGroup.get("quoteLineItemTotal")?.value || 0.0) | number: '1.3-3' }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Line Item list Price Sub Total</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteLineItemListPriceSubtotal"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Line Item Discount</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteLineItemDiscount"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <!-- Second Table -->
                                <table class="summary-table">
                                  <tbody>
                                    <tr>
                                      <td>Line Item Sub Total</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteLineItemSubtotal"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>General Discount</td>
                                      <td>
                                        <!-- <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true">
                                            <option value="percentage">Percentage</option>
                                            <option value="amount">Value</option>
                                        </select> -->
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteLineItemGeneralDiscountValue"
                                          (blur)="calculateCostSummary()"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td (click)="toggleFreightDetails()">
                                        Air Freight (In amount)<mat-icon>{{
                                          showFreightDetails
                                            ? "expand_less"
                                            : "expand_more"
                                        }}</mat-icon>
                                      </td>
                                      <td>
                                        <input type="hidden" formControlName="quoteLineItemFreightTotal" />
                                        <input
                                          type="text"
                                          matInput
                                          [value]="(secondFormGroup.get('quoteLineItemFreightTotal')?.value || 0) | number: '1.3-3'"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <!-- Freight details table, visible only if showFreightDetails is true -->
                                <div
                                  *ngIf="showFreightDetails && secondFormGroup.get('quoteLineItemFreight')?.value"
                                  style="display: flex; flex-direction: column"
                                >
                                  <table class="summary-table">
                                    <thead>
                                      <tr>
                                        <th style="padding: 10px">Description</th>
                                        <!-- <th style="padding: 10px">Cost Type</th> -->
                                        <th style="padding: 10px">Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let item of secondFormGroup.get(
                                            'quoteLineItemFreight'
                                          )?.value
                                        "
                                      >
                                        <td>{{ item.freightDescription }}</td>
                                        <!-- <td>{{ item.freightType }}</td> -->
                                      <td>{{ item.freightValue | number: '1.3-3' }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <!-- Third Table -->
                                <!-- <table
                                  class="summary-table"
                                  *ngIf="freightValues.length > 0"
                                >
                                  <tbody>
                                    <tr>
                                      <td>Documentation Charges (In amount)</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteDocumentationCharges"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Packing Charges (In amount)</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quotePackingCharges"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr class="total-row">
                                      <td><b>Total</b></td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          [formControlName]="'quoteLineItemTotal'"
                                          [disabled]="true"
                                          step="any"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table> -->

                                <table class="summary-table">
                                  <tbody>
                                  <tr>

                                      <td>Applicable Tax Profile</td>
                                      <td>
                                        {{ selectedTaxProfile?.applicableTaxProfile }} %
                                      <!-- {{ selectedTaxProfile?.taxPercentage || 0 }} % -->
                                      </td>
                                  </tr>
                                  <!-- <tr>
                                      <td>Tax Type</td>
                                      <td>
                                  
                                        {{quoteLineItemTaxType}}
                                      </td>
                                  </tr> -->
                                  <tr>
                                    <td>Tax Amount</td>
                                    <td>
                                      {{secondFormGroup.get("quoteLineItemTaxAmount")
                                            ?.value}}
                                    </td>
                                  </tr>
                                  </tbody>
                              </table>

                              </div>
                            </form>
                          </div> 
                          <!-- <div class="secondformcontainerfull" style="margin: 30px;float:right;">
                            <form [formGroup]="secondFormGroup">
                              <div class="floating-card-container">
                                <div class="floating-card">
                                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;">
                                    <span><b>Total <span *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode!== null">
                                      ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode}})
                                    </span></b></span>
                                    <span>{{secondFormGroup.get('quoteLineItemTotal')?.value || 0.00}}</span>
                                  </div>
                                  <div class="card-body mx-4">
                                     <div class="container">
                                        
                                        <div class="row">
                                          <hr>
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemListPriceSubtotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemDiscount'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemSubtotal'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>
                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true" readonly style="width: 100%; margin-bottom: 10px;">
                                                <option value="percentage">Percentage</option>
                                                 
                                                  
                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemGeneralDiscountValue'"  step="any"  (blur)="calculateCostSummary()" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemApplicableTaxProfile" style="width: 100%; margin-bottom: 10px;" (change)="calculateCostSummary()" [disabled]="true">
                                                <option *ngFor="let item of taxStatusData" [value]="item.taxId">
                                                  {{ item.nameOfTaxProfile }} - {{ item.country?.name }} - {{ item.taxType }} ({{item.regionName}}) - {{ item.taxNumber }} - {{ item.taxPercentage }} %
                                                </option>                                                  
                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemTaxAmount'"  step="any" readonly (blur)="calculateCostSummary()"/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Freight</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              
                                            </p>
                                            
                                          </div>
                                          
                                          <div style="display:flex;justify-content: flex-end;margin-bottom: 10px">
                                            <input type="number" matInput [formControlName]="'quoteLineItemFreightTotal'"  step="any" (blur)="calculateCostSummary()" readonly/>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                        <div class="row text-black">
                                  
                                          <div class="col-xl-12">
                                            <p class="float-end fw-bold" style="color: white !important;"> Total: 
                                              <input type="number" matInput [formControlName]="'quoteLineItemTotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                      
                                  
                                      </div>
                                  </div>
                                </div>
                              </div>
                        </form>
                        </div> -->

                      </div>

                  </div>
                  <div style="width:100%;">
                            
                            <form [formGroup]="firstFormGroup">
                            <div>

                                <!-- Purchase Order Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form1')">
                                    Purchase Order Details
                                    <mat-icon>{{ isForm1Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm1Expand" class="three-column-flex">

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Number</mat-label>
                                        <input matInput formControlName="purchaseOrderRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Date</mat-label>
                                        <input matInput [matDatepicker]="poDate" formControlName="purchaseOrderDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="poDate"></mat-datepicker-toggle>
                                        <mat-datepicker #poDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Ref Number</mat-label>
                                        <input matInput formControlName="rfqRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Date</mat-label>
                                        <input matInput [matDatepicker]="rfqDate" formControlName="rfqDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="rfqDate"></mat-datepicker-toggle>
                                        <mat-datepicker #rfqDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quote Ref Number</mat-label>
                                        <input matInput formControlName="quoteRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quotation Date</mat-label>
                                        <input matInput [matDatepicker]="quotationDate" formControlName="quotationDate">
                                        <mat-datepicker-toggle matSuffix [for]="quotationDate"></mat-datepicker-toggle>
                                        <mat-datepicker #quotationDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Expected Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="expectedDeliveryDate" formControlName="expectedDeliveryDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="expectedDeliveryDate"></mat-datepicker-toggle>
                                        <mat-datepicker #expectedDeliveryDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Company Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form2')">
                                    Buyer Company Details
                                    <mat-icon>{{ isForm2Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm2Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Buyer Name</mat-label>
                                        <input matInput formControlName="buyerName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form3')">
                                    Buyer Details
                                    <mat-icon>{{ isForm3Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm3Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Contact Person (Job Title)</mat-label>
                                        <input matInput formControlName="buyerContactPerson" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerContactEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerContactPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerContactFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerContactAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Supplier Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form4')">
                                    Supplier Details
                                    <mat-icon>{{ isForm4Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm4Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Supplier Contact Name</mat-label>
                                        <input matInput formControlName="supplierContactName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="supplierEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="supplierPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="supplierFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Company Email</mat-label>
                                        <input matInput formControlName="supplierCompanyEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Vessel Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form5')">
                                    Vessel Details
                                    <mat-icon>{{ isForm5Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm5Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Name</mat-label>
                                        <input matInput formControlName="vesselName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel IMO Number</mat-label>
                                        <input matInput formControlName="vesselIMONumber" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Type</mat-label>
                                        <input matInput formControlName="vesselType" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Class</mat-label>
                                        <input matInput formControlName="vesselClass" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Port Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form6')">
                                    Port Details
                                    <mat-icon>{{ isForm6Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm6Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Name</mat-label>
                                        <input matInput formControlName="portName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Code</mat-label>
                                        <input matInput formControlName="portCode" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETA</mat-label>
                                        <input matInput [matDatepicker]="vesselETA" formControlName="vesselETA" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETA"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETA></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETD</mat-label>
                                        <input matInput [matDatepicker]="vesselETD" formControlName="vesselETD" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETD"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETD></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </form>

                  </div>
                  <div style="width:100%;">
                    <form [formGroup]="paymentFormGroup">
                        <!-- Buyer Payment Terms -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form9')"
                        >
                            Buyer Payment Terms
                            <mat-icon>{{
                            isForm9Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm9Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Billing Address</mat-label>
                                <input matInput formControlName="billingAddress" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Applicable Tax Profile</mat-label>
                                <input
                                matInput
                                formControlName="applicableTaxProfile"
                                readonly
                                />
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyers Payment Terms</mat-label>
                                <input matInput formControlName="buyersPaymentTerms" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3;flex: 0 0 63.2%;margin-top:20px;">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Conditions</mat-label>
                                <textarea
                                matInput
                                formControlName="buyerTermsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Port Agent Details -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form10')"
                        >
                            Port Agent Details
                            <mat-icon>{{
                            isForm10Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm10Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agency Name</mat-label>
                                  <input matInput formControlName="portAgencyName" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Name</mat-label>
                                  <input matInput formControlName="portAgentName" readonly />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Number</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentPhoneNumber"
                                  />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Contact</mat-label>
                                  <input matInput formControlName="portAgentContact" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Fax</mat-label>
                                  <input matInput formControlName="portAgentPhoneFax" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Email ID</mat-label>
                                  <input matInput formControlName="portAgentEmail" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Address</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentAddress"
                                  readonly
                                  >
                              </mat-form-field>
                            </div>
                        </div>
                      </div>


                        <div class="header-form-header">
                          <span
                            style="
                              padding-left: 16px;
                              padding-top: 16px;
                              margin-bottom: 32px;
                              font-weight: bold;
                              display: flex;
                              justify-content: space-between;
                              padding-right: 20px;
                            "
                            (click)="toggleVisibility('form11')"
                          >
                           
                            <div style="display: flex; align-items: center;">
                              Freight Forwarder Details
                              <button
                                    mat-icon-button
                                    matSuffix
                                    type="button"
                                    matTooltipClass="mat-tooltip-custom"
                                    matTooltipPosition="left"
                                    [matTooltip]="freightTooltip">
        
                                    <mat-icon>info_outline</mat-icon>
        
                                  </button>
                             </div>
                            <mat-icon>{{ isForm11Expand ? "minimize" : "add" }}</mat-icon>
                          </span>

                          <div *ngIf="isForm11Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Freight Forwarder Company Name</mat-label>
                                <input matInput formControlName="freightCompanyName" readonly />
                              </mat-form-field>
                              
                              <button mat-icon-button matSuffix type="button">
                                            
                                <mat-icon matSuffix class="valid-icon"
                                    *ngIf="paymentFormGroup.get('portAgentId')?.valid && paymentFormGroup.get('portAgentId')?.value">
                                    check_circle
                                </mat-icon>
  
                                <mat-icon matSuffix class="invalid-icon" *ngIf="!paymentFormGroup.get('portAgentId')?.value">
                                  cancel
                                </mat-icon>
                        
                            </button>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>PIC</mat-label>
                                <input matInput formControlName="freightPIC" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Job Title</mat-label>
                                <input matInput formControlName="freightJobTitle" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Email ID</mat-label>
                                <input matInput formControlName="freightEmail" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="freightPhone" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="freightFax" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="freightAddress" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Packaging</mat-label>
                                <input 
                                  matInput 
                                  formControlName="freightPackaging" 
                                  readonly 
                                  [matTooltip]="paymentFormGroup.get('freightPackaging')?.value" 
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Mode of Transport</mat-label>
                                <input 
                                  matInput 
                                  formControlName="freightTransportMode" 
                                  readonly 
                                  [matTooltip]="paymentFormGroup.get('freightTransportMode')?.value" 
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        </div>


                        <!-- Terms and Conditions -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form12')"
                        >
                            Terms and Conditions
                            <mat-icon>{{
                            isForm12Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm12Expand" class="three-column-flex">
                            <div class="form-item-row-header" style="grid-column: span 3;margin-top:20px">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Condition</mat-label>
                                <!-- <input
                                matInput
                                formControlName="termsAndConditions"
                                > -->
                                <textarea
                                matInput
                                formControlName="termsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>

                            
                            
                            <div class="form-item-row-header">
                            <div class="file-name-box">
                                {{
                                getHeaderAttachmentCount() === 0
                                    ? "No files chosen"
                                    : getHeaderAttachmentCount() === 1
                                    ? "1 file chosen"
                                    : getHeaderAttachmentCount() + " files chosen"
                                }}
                                <button
                                    mat-icon-button
                                    *ngIf="getHeaderAttachmentCount() > 0"
                                    (click)="togglePreview(true, 'generalAttachment')"
                                    type="button"
                                >
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </form>
                  </div>
                  <div style="width:100%;display: flex;justify-content: center;align-items: center;margin-top:20px">
                    <!-- <button mat-raised-button color="warn" (click)="rejectPO()" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #FF8900;margin-right:5px"
                    [disabled]="status === 'Rejected' || status === 'Approved'">
                     {{ status === 'Rejected' ? 'Rejected' : 'Reject' }}</button>
                    <button mat-raised-button color="primary" (click)="acceptPO()" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #1F7E3F;margin-left:5px;"
                    [disabled]="status === 'Rejected' || status === 'Approved'">
                      {{ status === 'Approved' ? 'Accepted' : 'Accept' }}</button> -->
                    <button mat-raised-button color="warn" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" (click)="rejectPO()" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #FF8900;margin-right:5px">
                     Reject</button>
                    <button mat-raised-button color="primary" *ngIf="headerResponse?.purchaseOrderStatus !== 6 && headerResponse?.purchaseOrderStatus !== 7" (click)="acceptPO()" style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;background-color: #1F7E3F;margin-left:5px;">
                      Accept</button>

                      <button
                      mat-icon-button
                      matSuffix
                      matTooltipClass="mat-tooltip-custom"
                      matTooltipPosition="left"
                      [matTooltip]="reviewTooltip">
                      <mat-icon>info_outline</mat-icon>
                    </button>
                  </div>
              </mat-card-content>
          </mat-card>
      </div>
  </div>












    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
                <p class="mb-6">You want to save this as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>
    
        </div>
    </div>
</div>


<div
  class="blur"
  *ngIf="previewSection"
  (click)="togglePreview(false, '')"
></div>

<div class="carousel-container" *ngIf="previewSection">
  <!-- Close Button -->
  <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <!-- Carousel Content -->
  <div class="carousel">
    <!-- Previous Button -->
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <!-- Image/PDF Preview -->
    <div class="carousel-image-container">
      <ng-container *ngIf="previewDoc[currentIndex]">
        <div
          class="carousel-preview-inner"
          *ngIf="isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <pdf-viewer
            [src]="previewDoc[currentIndex].dataUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="pdf-content"
          ></pdf-viewer>
        </div>

        <div
          class="carousel-preview-inner"
          *ngIf="!isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <img
            [src]="previewDoc[currentIndex]?.dataUrl"
            alt="attachment image"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <!-- Next Button -->
    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>




<div
  class="blur"
  *ngIf="showAcceptOrder"
  (click)="cancel()"
></div>

<!-- accept-order-modal.component.html -->
<!-- <div class="namemodal" style="
    width: 25%;
    padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    
    <h2 style="text-align: center;font-weight: bold;margin-bottom:30px;font-size: 26px;">Accept Order</h2>

    
    <div class="mb-6" style="display: flex;justify-content: space-between;align-items: center;">
      <label class="block text-left mb-2 font-medium">Order Confirmation Number:</label>
      <input type="text" [(ngModel)]="orderConfirmationNumber"
        class="w-full bg-gray-200 rounded-lg px-4 py-2 focus:outline-none" />
    </div>

    
    <div class="mb-8" style="display: flex;justify-content: space-between;align-items: center;">
      <label class="block text-left mb-2 font-medium">Estimated Delivery Date:</label>
      <div class="relative" style="display:flex;justify-content:center;">
        <input matInput [matDatepicker]="deliveryPicker" [(ngModel)]="deliveryDate"
          class="w-full bg-gray-200 rounded-lg px-4 py-2 focus:outline-none" />
        <mat-datepicker-toggle matSuffix [for]="deliveryPicker"
          class="absolute right-2 top-2 text-gray-600"></mat-datepicker-toggle>
        <mat-datepicker #deliveryPicker></mat-datepicker>
      </div>
    </div>

    
    <div class="mb-10" style="display: flex;justify-content: space-between;align-items: center;">
      <label class="block text-left mb-2 font-medium">Estimated Shipping Date:</label>
      <div class="relative" style="display:flex;justify-content:center;">
        <input matInput [matDatepicker]="shippingPicker" [(ngModel)]="shippingDate"
          class="w-full bg-gray-200 rounded-lg px-4 py-2 focus:outline-none" />
        <mat-datepicker-toggle matSuffix [for]="shippingPicker"
          class="absolute right-2 top-2 text-gray-600"></mat-datepicker-toggle>
        <mat-datepicker #shippingPicker></mat-datepicker>
      </div>
    </div>

  
    <div style="display: flex;justify-content: center;align-items: center;margin-top: 50px;">
      <button (click)="cancel()"
        style="border-radius: 5px; font-size: 18px; padding: 8px 20px;margin-right:8px">
        Cancel
      </button>
      <button (click)="acceptOrder()"
        style="border-radius: 5px; font-size: 18px; padding: 8px 20px;margin-left:8px;background-color: #1F7E35;">
        Accept Order
      </button>
    </div>
  </div>
</div> -->



<div class="namemodal" *ngIf="showAcceptOrder" style="width: 27%; padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <!-- Title -->
    <h2 style="text-align: center; font-weight: bold; margin-bottom:35px; font-size: 26px;">
      Accept Order
    </h2>

    <!-- Order Confirmation Number -->
    <div class="mb-6" style="display: flex; align-items: center;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;justify-content: space-between;">Order Confirmation Number:</label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <!-- <input matInput [(ngModel)]="orderConfirmationNumber"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" /> -->
        <input matInput [(ngModel)]="orderConfirmationNumber"
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" readonly />
      </mat-form-field>
    </div>

    <!-- Estimated Delivery Date -->
    <div class="mb-6" style="display: flex; align-items: center;justify-content: space-between;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;">Estimated Delivery Date: <span style="color: red;"> *</span></label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <input matInput [matDatepicker]="deliveryPicker" [(ngModel)]="deliveryDate" #deliveryCtrl="ngModel" required
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" />
        <mat-datepicker-toggle matSuffix [for]="deliveryPicker" ></mat-datepicker-toggle>
        <mat-datepicker #deliveryPicker></mat-datepicker>
        <mat-error *ngIf="deliveryCtrl.invalid && deliveryCtrl.touched">
          Delivery date is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Estimated Shipping Date -->
    <div class="mb-10" style="display: flex; align-items: center;justify-content: space-between;">
      <label style="min-width: 200px; font-weight: 500;font-size: 15px;">Estimated Shipping Date: <span style="color: red;"> *</span></label>
      <mat-form-field appearance="fill" class="flex-1" style="margin: 0;width:250px;">
        <input matInput [matDatepicker]="shippingPicker" [(ngModel)]="shippingDate" #shippingCtrl="ngModel" required
          style="width: 100%; padding:0px !important;"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" />   
        <mat-datepicker-toggle matSuffix [for]="shippingPicker"></mat-datepicker-toggle>
        <mat-datepicker #shippingPicker></mat-datepicker>
        <mat-error *ngIf="shippingCtrl.invalid && shippingCtrl.touched">
          Shipping date is required
        </mat-error>
    
        
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
      <button (click)="cancel()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-right:8px; background:#e5e5e5;">
        Cancel
      </button>
      <button (click)="acceptOrder()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-left:8px; background-color: #1F7E35; color:#fff;">
        Accept Order
      </button>
    </div>
  </div>
</div>

<div
  class="blur"
  *ngIf="showOrderConfirmed"
  (click)="cancel()"
></div>
<div class="namemodal" *ngIf="showOrderConfirmed" style="width: 25%; padding: 10px 20px;">

  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <h2 style="font-size:24px; font-weight:bold; margin-bottom:20px;">
      Order confirmed!
    </h2>

    <p style="font-size:15px; margin-bottom:15px;">
      Order: <strong>"{{this.orderConfirmationNumber}}"</strong> is confirmed!
    </p>

    <!-- <p style="margin-bottom:30px; font-size:15px;">
      Click <a href="#" style="color:#007BFF; text-decoration:underline;">here</a> for an overview of confirmed order.
    </p> -->

    <p style="margin-bottom:30px; font-size:15px;">
      Click 
      <a href="javascript:void(0);" 
        style="color:#007BFF; text-decoration:underline;" 
        (click)="goToConfirmedOrderOverview()">
        here
      </a> 
      for an overview of confirmed order.
    </p>
    <div style="text-align: center;">
      <button (click)="closeAcceptOrderConfirmation()"
        style="background-color:#1F7E35;color:#fff;font-size:16px;padding:8px 28px;border:none;border-radius:6px;cursor:pointer;">
        Done
      </button>
    </div>
  </div>
  
</div>


<div
  class="blur"
  *ngIf="showRejectOrder"
  (click)="cancel()"
></div>

<div class="namemodal" *ngIf="showRejectOrder" style="width: 25%; padding: 10px 20px;">
  <div class="modalContent bg-white rounded-2xl shadow-xl w-[520px] p-8">
    <!-- Title -->
    <h2 style="text-align: center; font-weight: bold; margin-bottom:35px; font-size: 26px;">
      Reject Order
    </h2>

    <!-- Reason for rejection (external label + mat-form-field with native select) -->
    <div class="mb-6" style="display: flex; align-items: center;">
      <label style="min-width: 160px; font-weight: 500; font-size: 16px;">Reason for rejection:</label>
      <!-- <mat-form-field appearance="fill" class="flex-1" style="width: 100%;">
        <select matNativeControl [(ngModel)]="rejectionReason"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none">
          <option value="">Please select</option>
          <option *ngFor="let reason of rejectionReasons" [value]="reason.value">{{ reason.label }}</option>
        </select>
      </mat-form-field> -->
      <mat-form-field appearance="fill" class="flex-1" style="width: 100%;">
        <select matNativeControl [(ngModel)]="rejectionReason"
                class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none">
          <option value="">Please select</option>
          <option *ngFor="let item of rejectionReasons" [value]="item.id">
            {{ item.reason }}
          </option>
        </select>
      </mat-form-field>
    </div>

    <!-- Message for rejection (external label + mat-form-field textarea) -->
    <div class="mb-6">
      <label style="min-width: 200px; font-weight: 500; font-size: 16px; margin-top: 6px;margin-bottom: 10px;">
        Type the message for rejection here:
      </label>
      <mat-form-field appearance="fill" class="flex-1" style="width: 100%;">
        <textarea matInput [(ngModel)]="rejectionMessage"
          class="bg-gray-200 rounded-lg px-3 py-1.5 focus:outline-none" rows="4"></textarea>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;margin-bottom: 20px;">
      <button (click)="cancel()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-right:8px; background:#e5e5e5;">
        Cancel
      </button>
      <button (click)="rejectOrder()"
        style="border:none;border-radius: 5px; font-size: 16px; padding: 6px 18px; margin-left:8px; background-color: #E40000; color:#fff;">
        Reject Order
      </button>
    </div>
  </div>
</div>
